function handleNativeShare(url) {
  if (navigator.share) {
    navigator.share({
      title: document.title,
      text: 'Check this out!',
      url: url
    }).catch((err) => {
      console.warn('Sharing failed or canceled:', err);
    });
  } else {
    // Show fallback
    const fallback = document.querySelector('.share-button__fallback');
    if (fallback) {
      fallback.style.display = 'block';
    }
  }
}

function copyShareLink(link, sectionId) {
  navigator.clipboard.writeText(link).then(() => {
    const msg = document.getElementById(`ShareMessage-${sectionId}`);
    if (msg) {
      msg.classList.remove('hidden');
      msg.textContent = 'Link copied to clipboard!';
    }
  });
}
